export class CalcolaDimensioniResponseVO {
  documentsSize: Map<string, number>;
  totalSize: number;
  validSize: boolean;
}
